import apiClient from '../lib/apiClient';

const energyService = {
  getEnergy() {
    return apiClient.request('/user/energy');
  }
};

export default energyService;
